module.exports = __webpack_public_path__ + "img/icon_star.d554785e.svg";